import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { getWeekday } from '@utils/utils'
import { Checkbox, LightBox } from '@lion-design/core';
import { RootState } from '@Redux/detail/store';
import { I_NoteList } from '@Redux/detail/Itineraries/interfaces';
import DomainByEnv from '@utils/domainByEnv';
import { I_Group } from '@Redux/detail/Group/interfaces';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface I_PrintProps {
    isOpen: boolean;
    togglePrintLbx: (isOpen: boolean) => void;
}

function PrintLightbox({ isOpen, togglePrintLbx }: I_PrintProps) {
    const moduleName = 'printInfo';
    const {
        NoteList,
        LeaveTeamReg,
        SafeReg,
        ActiveNote,
        AntiepReg,
        OptionalInfoList,
        ItinnotesReg,
    } = useSelector((store: RootState) => store.itinerariesReducer);
    const { GroupInfo } = useSelector((store: RootState) => store.groupReducer);
    const [checkedItems, setCheckItems] = useState<string[]>([]);
    const { t } = useTranslation();

    const FEE = OptionalInfoList.length > 0 ? [{ Title: 'FEE', CTitle: '自費活動', Desc: '' }] : [];
    const OFF = LeaveTeamReg ? [{ Title: 'OFF', CTitle: '團體航班規定事項', Desc: '' }] : [];
    const SAFE = SafeReg ? [{ Title: 'SAFE', CTitle: '安全守則', Desc: '' }] : [];
    const OPTN = ActiveNote ? [{ Title: 'OPTN', CTitle: '活動附註', Desc: '' }] : [];
    const ANT = AntiepReg ? [{ Title: 'ANT', CTitle: '防疫規範', Desc: '' }] : [];
    const ITIN = ItinnotesReg ? [{ Title: 'ITIN', CTitle: '行程備註', Desc: '' }] : [];

    const Opts = [
        { Title: 'FEATURE', CTitle: '行程特色', Desc: '' },
        // { Title: 'DAILY', CTitle: '每日行程', Desc: '' },
        ...OFF,
        ...SAFE,
        ...OPTN,
        ...FEE,
        ...NoteList,
        ...ANT,
        ...ITIN,
    ];

    const matchItems = Opts.filter((item: I_NoteList) => checkedItems.indexOf(item.Title) !== -1);

    function hangdleAllchecked() {
        if (matchItems.length === Opts.length) return true;
        return false;
    }

    function handleSingleChecked(item: I_NoteList) {
        if (checkedItems.indexOf(item.Title) !== -1) return true;
        return false;
    }

    function handlePrint() {
        const printItem = matchItems.map((item) => item.Title).join(',');
        const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
        const { IsPreview }: I_Group = JSON.parse(travelinfo!);

        const paramObj: {
            [key: string]: string | boolean;
        } = {
            NormGroupID: GroupInfo.NormGroupID,
            GroupID: GroupInfo.GroupID,
            PrintItem: printItem,
            IsPreview,
        };
        const paramUrl = Object.keys(paramObj)
            .map((item: string) => `${item}=${paramObj[item]}`)
            .join('&');
        const printUrl = `${DomainByEnv(false)}/detail/print?${paramUrl}`;
        window.open(printUrl, '_blank');
    }

    return (
        <LightBox
            className={cN(moduleName, styles[`${moduleName}`])}
            open={isOpen}
            ToggleLightBox={() => {
                setCheckItems([]);
                togglePrintLbx(false);
            }}
        >
            <div className={styles.title}>選擇行程資料</div>
            <div className={styles.group_info}>
                <div>
                    出發日期：{getWeekday(GroupInfo.GoDate)}
                </div>
                <div>
                    {t('GroupID')}：{GroupInfo.GroupID}
                </div>
                <div>行程：{GroupInfo.TourID}</div>
            </div>
            <div className={styles.print_options}>
                <div className={styles.note}>
                    已含 <span>「行程基本資料」</span>
                    ，可再加選以下項目：
                </div>
                <div className={styles.CheckBoxes}>
                    <Checkbox
                        onChange={(active: boolean) => {
                            if (active) {
                                setCheckItems([...Opts.map((item) => item.Title)]);
                            } else {
                                setCheckItems([]);
                            }
                        }}
                        checked={hangdleAllchecked()}
                        title="全選"
                        checkFillColor="#669" //打勾變色的css
                        checkedBackgroundColor="transparent"
                    />
                    {Opts.map((item: I_NoteList) => {
                        const checkboxProps = {
                            onChange: (active: boolean) => {
                                const matchIdx = checkedItems.indexOf(item.Title);
                                const items = [...checkedItems];
                                if (matchIdx === -1) {
                                    items.push(item.Title);
                                } else {
                                    items.splice(matchIdx, 1);
                                }
                                setCheckItems(items);
                            },
                            checked: handleSingleChecked(item),
                            title: item.CTitle,
                            disabled: false,
                            checkFillColor: '#669', //勾勾顏色
                            checkedBackgroundColor: 'transparent', //勾起來的時候的背景色
                        };
                        return <Checkbox {...checkboxProps} key={item.Title} />;
                    })}
                </div>
            </div>
            <div className={styles.Footer}>
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        setCheckItems([]);
                        togglePrintLbx(false);
                        handlePrint();
                    }}
                >
                    列印本頁
                </button>
            </div>
        </LightBox>
    );
}

export default PrintLightbox;
